/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { BillingLogsJournalPaginatedResponse } from '../model/billingLogsJournalPaginatedResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class BillingLogsOperatorService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Get all billing logs by filters
     * Get all billing logs by filter
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the billing logs journal by this column
     * @param orgId organization identifier in optional filter
     * @param serviceType Service Type
     * @param vcdsServiceType VCDS Service Type
     * @param entityId Entity UUID
     * @param billingEntityOptionalQueryId Billing Entity Primary Id In Optional Filter
     * @param billingModule Billing Modules
     * @param startTime Time at which query starts
     * @param endTime Time at which query ends
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getBillingLogsJournal(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'orgId' | 'serviceType' | 'vcdsServiceType' | 'entityUuid' | 'entityId' | 'module' | 'eventTs' | 'createdTs', orgId?: string, serviceType?: 'VCDR' | 'VMCFS', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', entityId?: string, billingEntityOptionalQueryId?: number, billingModule?: 'SUBSCRIPTION_PROCESSOR' | 'EVENT_PROCESSOR' | 'USAGE_DOWNLOADER' | 'CSP_PROCESSOR' | 'SDDC_QUOTA', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<BillingLogsJournalPaginatedResponse>;
    public getBillingLogsJournal(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'orgId' | 'serviceType' | 'vcdsServiceType' | 'entityUuid' | 'entityId' | 'module' | 'eventTs' | 'createdTs', orgId?: string, serviceType?: 'VCDR' | 'VMCFS', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', entityId?: string, billingEntityOptionalQueryId?: number, billingModule?: 'SUBSCRIPTION_PROCESSOR' | 'EVENT_PROCESSOR' | 'USAGE_DOWNLOADER' | 'CSP_PROCESSOR' | 'SDDC_QUOTA', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BillingLogsJournalPaginatedResponse>>;
    public getBillingLogsJournal(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'orgId' | 'serviceType' | 'vcdsServiceType' | 'entityUuid' | 'entityId' | 'module' | 'eventTs' | 'createdTs', orgId?: string, serviceType?: 'VCDR' | 'VMCFS', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', entityId?: string, billingEntityOptionalQueryId?: number, billingModule?: 'SUBSCRIPTION_PROCESSOR' | 'EVENT_PROCESSOR' | 'USAGE_DOWNLOADER' | 'CSP_PROCESSOR' | 'SDDC_QUOTA', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BillingLogsJournalPaginatedResponse>>;
    public getBillingLogsJournal(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'orgId' | 'serviceType' | 'vcdsServiceType' | 'entityUuid' | 'entityId' | 'module' | 'eventTs' | 'createdTs', orgId?: string, serviceType?: 'VCDR' | 'VMCFS', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', entityId?: string, billingEntityOptionalQueryId?: number, billingModule?: 'SUBSCRIPTION_PROCESSOR' | 'EVENT_PROCESSOR' | 'USAGE_DOWNLOADER' | 'CSP_PROCESSOR' | 'SDDC_QUOTA', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getBillingLogsJournal.');
        }
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getBillingLogsJournal.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vcdsServiceType, 'vcds-service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>entityId, 'entity-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>billingEntityOptionalQueryId, 'billing-entity-optional-query-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>billingModule, 'billing-module');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startTime, 'start-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endTime, 'end-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/logs-journal`;
        return this.httpClient.request<BillingLogsJournalPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
